export const colors = {
  primary: '#6A0098',
  primary1: '#470066',
  primary4: '#F2EAF7',
  primary5: '#E1CCEA',
  secondary: '#F4901F',
  white: '#ffffff',
  black: '#000000',
  blackLight: '#202020',

  success: '#1ED286',
  successText: '#0A7D4F', // AA contrast for text on white / #F2F2F2
  success1: '#6CEAB5',
  success2: '#C5F7E2',

  error1: '#C8102E',
  error2: '#F6898A',
  error3: '#FDE7E8',

  note1: '#F7F700',
  note2: '#FFFF99',
  note3: '#FFFFCC',

  info1: '#43DDFF',
  info2: '#CEEFF7',
  info3: '#EBFBFF',

  text1: '#323232',
  text2: '#4D4D4D',
  text3: '#666666',
  text4: '#6B6B6B', // AA contrast on #F2F2F2 and white
  text5: '#DBDBDB',
  text6: '#F2F2F2',
  text7: '#FFFFFF',

  icon1: '#323232',
  icon2: '#4D4D4D',
  icon3: '#666666',
  icon4: '#999999',
  icon5: '#DBDBDB',
  icon6: '#F2F2F2',
  icon7: '#FFFFFF',

  background1: '#323232',
  background2: '#4D4D4D',
  background3: '#666666',
  background4: '#999999',
  background5: '#DBDBDB',
  background6: '#F2F2F2',
  background7: '#FFFFFF',

  border1: '#323232',
  border2: '#4D4D4D',
  border3: '#666666',
  border4: '#999999',
  border5: '#DBDBDB',
  border6: '#F2F2F2',
  border7: '#FFFFFF',
  border8: '#D9D9D9',

  green1: '#3ADF9E',
};

export const boldTypes = {
  bold: '700',
  normal: '400',
};

export const baseWidths = {
  mobile: 620,
};

export const footer = {
  height: 230,
  mobileHeight: 654
}

export const header = {
  height: 96,
  mobileHeight: 52
} // TODO: Add back the widget when we have the new giveaway, header height should be 96 + 50 = 146

export const headerWidget = {
  height: 0, // 50
  mobileHeight: 0 // 44
}